import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Dialog, withStyles } from "@material-ui/core";
import * as actions from './store/deviceCaseSupportedActions';
import * as diagnoseCaseActions from '../../sc-admin/AdminDiagnoseCase/store/adminDiagnoseCaseActions';
import AppLogoLoading from "../../sc-logo";
import DeviceCaseSupportedForm from "./DeviceCaseSupportedForm";
import { checkIfLoading, hasPermission, parseURL } from "../../sc-utilities";
import * as Yup from "yup";
import History from "../../../History";

const styles = (theme) => ({
    loadingScreen: {
        backgroundColor: "transparent",
        boxShadow: "none",
    },
});

const DeviceCaseSupportedDetails = (props) => {
    const { classes, onFetchDeviceModels, activeCustomerID, onFetchDiagnoseCases, translations, permissions, onFetchDeviceCaseSupported, onEditDeviceCaseSupported, onCreateDeviceCaseSupported } = props;

    const searchParams = parseURL(window.location.href);
    const [deviceCase, setDeviceCase] = useState(null);

    const [loading, setLoading] = useState({ deviceCase: false });
    const isEdit = window.location.href.includes("update");

    const getDeviceCase = async () => {
        setLoading(prevState => { return { ...prevState, deviceCase: true } });
        const result = await onFetchDeviceCaseSupported({ DeviceCaseSupportedID: searchParams?.deviceCaseSupportedID, ActiveCustomerID: activeCustomerID });
        if (result) {
            setDeviceCase(result);
        }
        setLoading(prevState => { return { ...prevState, deviceCase: false } });
    };

    useEffect(() => {
        if (isEdit) {
            getDeviceCase();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCreate = async (data) => {
        const DiagnoseCaseIDs = data.DiagnoseCases.map((option) => option.DiagnoseCaseID);
        const DeviceModelIDs = data.DeviceModels.map((option) => option.value);
        await onCreateDeviceCaseSupported({ ProductType: data.ProductType, DiagnoseCaseIDs: DiagnoseCaseIDs, DeviceModelIDs: DeviceModelIDs, Name: data.Name, ActiveCustomerID: activeCustomerID });
        History.goBack();

    }
    const handleEdit = async (data) => {
        const DiagnoseCaseIDs = data.DiagnoseCases.map((option) => option.DiagnoseCaseID);
        const DeviceModelIDs = data.DeviceModels.map((option) => option.value);
        await onEditDeviceCaseSupported({ DeviceCaseSupportedID: searchParams?.deviceCaseSupportedID, ProductType: data.ProductType, DiagnoseCaseIDs: DiagnoseCaseIDs, DeviceModelIDs: DeviceModelIDs, Name: data.Name, ActiveCustomerID: activeCustomerID });
        History.goBack();
    }

    const initialValues = {
        Name: deviceCase?.Name || "",
        ProductType: deviceCase?.ProductType || "work",
        DiagnoseCases: deviceCase?.DeviceCaseSupportedDiagnoseCases?.map(diagnoseCase => { return { DiagnoseCaseID: diagnoseCase.DiagnoseCaseID, OriginalLongName: diagnoseCase.LongName } }) || [],
        DeviceModels: deviceCase?.DeviceCaseSupportedDeviceModels?.map(deviceModel => { return { value: deviceModel.DeviceModelID, displayValue: `${deviceModel.Vendor} - ${deviceModel.Model}` } }) || []
    }

    const formSettings = {
        Validation: {
            Name: Yup.string().required(),
            DiagnoseCases: Yup.string().required(),
            ProductType: Yup.string().required(),
        },
        FormTitle: isEdit ? translations["device_case_supported_details"] || "Device case supported details" : translations['create_device_case_supported'] || 'Create device case supported',
        ButtonSubmit: hasPermission(permissions, isEdit ? 'system_device_case_supported_update' : 'system_device_case_supported_create') && {
            Title: translations["save"] || "SAVE"
        }
    }
    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={checkIfLoading(loading)} PaperProps={{ classes: { root: classes.loadingScreen } }}>
        <AppLogoLoading />
    </Dialog>

    return <>
        {checkIfLoading(loading) ? loadingScreen : <DeviceCaseSupportedForm onFetchDiagnoseCases={onFetchDiagnoseCases} onFetchDeviceModels={onFetchDeviceModels} activeCustomerID={activeCustomerID} permissions={permissions} formSettings={formSettings} initialValues={initialValues} handleSubmit={isEdit ? handleEdit : handleCreate} translations={translations} isEdit={isEdit} />}
    </>
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};
const mapDispatchToProps = dispatch => {
    return {
        onFetchDeviceCaseSupported: params => dispatch(actions.fetchDeviceCaseSupported(params)),
        onEditDeviceCaseSupported: data => dispatch(actions.editDeviceCaseSupported(data)),
        onCreateDeviceCaseSupported: data => dispatch(actions.createDeviceCaseSupported(data)),
        onFetchDiagnoseCases: params => dispatch(diagnoseCaseActions.fetchAdminDiagnoseCases(params)),
        onFetchDeviceModels: params => dispatch(actions.fetchDeviceModels(params))
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(DeviceCaseSupportedDetails));
